
<template>


<!-- Для малого экрана-->
<v-navigation-drawer  v-if="$vuetify.breakpoint.mdAndDown"   v-model="$store.state.ui.leftNav"  width="260"     app clipped    >
<v-card  flat  style="margin-top:24px;margin-left:5px; ">
     <div v-for="item in leftMenu.items" @click="changeContentType(item )"   >
       <div @click.stop="" style="height:20px;background-color:#273C51" v-if="item.content == 'line'"></div>

        <v-btn small style="text-transform: none !important;font:bold 14px Roboto, Tachoma, Arial, sans-serif" v-else color="#4A76A8" flat block>
           <v-icon :color="item.iconColor" left> {{item.icon}}</v-icon>
          {{item.name}}
          <v-spacer></v-spacer>
         <span v-show="false" v-if="counters[item.count] > 0"> {{ counters[item.count] }} </span>
          <div v-if="item.count == 'vk_profiles'">
            <div v-if="accCount">
            <span style="color:green">{{accCount.vk_profiles[0]}}</span> <span> / </span>  <span style="color:red">{{accCount.vk_profiles[1]}}</span>
          </div>
          </div>
          <div v-if="item.count == 'vk_profiles_friends'">
            <div v-if="accCount">
            <span style="color:green">{{accCount.vk_profiles_friends[0]}}</span><span > / </span><span   style="color:red">{{accCount.vk_profiles_friends[1]}}</span>
          </div>
          </div>
          <div v-if="item.count == 'vk_profiles_others'">
            <div v-if="accCount">
            <span style="color:green">{{accCount.vk_profiles_others[0]}}</span><span > / </span><span   style="color:red">{{accCount.vk_profiles_others[1]}}</span>
          </div>
          </div>
          <div v-if="item.count == 'vk_profiles_autoreg'">
            <div v-if="accCount">
            <span style="color:green">{{accCount.vk_profiles_autoreg[0]}}</span><span > / </span><span   style="color:red">{{accCount.vk_profiles_autoreg[1]}}</span>
          </div>
          </div>
        </v-btn>
     </div>
</v-card>

</v-navigation-drawer>





<!-- Для среднего экрана-->
<v-navigation-drawer  v-else  v-model="$store.state.ui.leftNav"  width="260"     app clipped   class="colorA" >


<v-card    style="margin-top:24px;margin-left:5px; ">
<div v-for="item in leftMenu.items" @click="changeContentType(item )"   >

      <div @click.stop="" style="height:20px;background-color:#273C51" v-if="item.content == 'line'"></div>

       <v-btn small style="text-transform: none !important;font:bold 14px Roboto, Tachoma, Arial, sans-serif" v-else color="#4A76A8" flat block>
          <v-icon :color="item.iconColor" left> {{item.icon}}</v-icon>
         {{item.name}}
         <v-spacer></v-spacer>
        <span v-show="false" v-if="counters[item.count] > 0"> {{ counters[item.count] }} </span>
         <div v-if="item.count == 'vk_profiles'">
           <div v-if="accCount">
           <span style="color:green">{{accCount.vk_profiles[0]}}</span> <span> / </span>  <span style="color:red">{{accCount.vk_profiles[1]}}</span>
         </div>
         </div>
         <div v-if="item.count == 'vk_profiles_friends'">
           <div v-if="accCount">
           <span style="color:green">{{accCount.vk_profiles_friends[0]}}</span><span > / </span><span   style="color:red">{{accCount.vk_profiles_friends[1]}}</span>
         </div>
         </div>
         <div v-if="item.count == 'vk_profiles_others'">
           <div v-if="accCount">
           <span style="color:green">{{accCount.vk_profiles_others[0]}}</span><span > / </span><span   style="color:red">{{accCount.vk_profiles_others[1]}}</span>
         </div>
         </div>
         <div v-if="item.count == 'vk_profiles_autoreg'">
           <div v-if="accCount">
           <span style="color:green">{{accCount.vk_profiles_autoreg[0]}}</span><span > / </span><span   style="color:red">{{accCount.vk_profiles_autoreg[1]}}</span>
         </div>
         </div>
       </v-btn>

     </div>
</v-card>



</v-navigation-drawer>







</template>




<script>
 import axios from 'axios'
 export default {
   props: ['leftMenu' ],
   data: function(){
    return {
accCount:false
    }
   },


   methods : {
    changeContentType (contentType ){
       this.$router.push({name:contentType.content})
       this.$vuetify.goTo(0)
       //this.$store.commit('leftNavOn', true )
      // this.leftMenu.items.forEach(function(item,i,arr){ item.selected=false })
      // contentType.selected = true
      //this.$emit('typeChenge', contentType.content)
    },
    getAccCount(){

      axios('http://'+this.$store.state.localhost+'/'+this.$store.state.path+'/resources/accounts/acc_count_get.php', {
         method: 'get',
         }).then(response => {
           this.accCount = response.data
         })
    },
  },

  computed: {
    counters(){
      return this.$store.state.ui.counters
    }
  },
created(){
  this.getAccCount()
},
  }
</script>

<style>
#navigator_wrapper{
margin-top: 22px;
}


#nenuTitle {
font-size: 1.4em;
margin-bottom: 5px;
text-align:center;
color: #4A76A8;

}

.item{

  margin-top: 15px;
  padding-left:15px;
  text-align:left;
  cursor: pointer;
  text-decoration: none;
  display: block;
  font-size: 1.4em;
  font-weight: bold;
  color: #707070;
  position: relative;
  transition: .3s linear;
}

.item:after{

  font-family: FontAwesome;
  position: absolute;
  right: 5px;
  color: white;
  transition: .2s linear;
}

.item1:after{
  color: white;
  transition: .2s linear;
}
.item1:hover{

  color: #F5F5F5;
}

.item:hover{
  background: #80C8A0;
  color: #F5F5F5;
}

.colorA {
  background-color: rgba(0, 0, 0, 0) !important;
}

.selected_class{

	background:#507299;
	color: #F5F5F5 !important;

}
.v-navigation-drawer__border {
 visibility: hidden !important;
}


</style>
